export default {
  slots: {
    title: 'text-white font-barlow',
    description: 'text-white/80 font-barlow',
    base: 'md:p-0 cursor-pointer size-6',
    close: 'size-6 text-white cursor-pointer hover:text-white',
  },
};
